import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  PROMOTION_LIST,
  PROMOTION_CREATE,
  PROMOTION_UPDATE,
  PROMOTION_DELETE,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'promotion' })
export default class Promotion extends VuexModule {
  list: any = [];

  @Mutation
  mutatePromotion(promotion) {
    this.list = promotion;
  }

  @Action({ commit: 'mutatePromotion' })
  FetchPromotion() {
    return Vue.axios({
      url: BASE_URL + PROMOTION_LIST,
      method: M_POST,
      data: {},
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const promotion = data.data;
          return promotion;
        } else {
          throw data;
        }
      })
      .catch((err) => err);
  }

  @Action
  AddPromotion(params) {
    return Vue.axios({
      url: BASE_URL + PROMOTION_CREATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  EditPromotion(params) {
    return Vue.axios({
      url: BASE_URL + PROMOTION_UPDATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  DeletePromotion(params) {
    return Vue.axios({
      url: BASE_URL + PROMOTION_DELETE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
